/**
 * Font stack for text that must render emoji flags correctly across platforms.
 *
 * Extracted at its fourth copy — InviteUserForm and AdminCompaniesPage each grew their own,
 * and the agents pages were about to make it four definitions of the same string.
 */
export const emojiFontStack =
  '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", system-ui, sans-serif';
